import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Divider } from '@mui/material';
import { Typography, LinearProgress } from '@totalsoft/rocket-ui';

const ProductRow = ({ left, right, leftClassName, computing }) => {
  return (
    <React.Fragment>
      {left && (
        <Grid item xs={right !== undefined && right !== null ? 6 : 12} className={leftClassName}>
          <Typography>{left}</Typography>
        </Grid>
      )}
      {right !== undefined && right !== null && !computing && (
        <Grid item xs={left ? 6 : 12}>
          <Typography color='primary' align='right'>
            {right}
          </Typography>
        </Grid>
      )}
      {computing && (
        <Grid item xs={left ? 6 : 12}>
          <LinearProgress color='primary' sx={{ height: '2px' }} mt={4} mb={3} />
        </Grid>
      )}
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </React.Fragment>
  );
};

ProductRow.propTypes = {
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  leftClassName: PropTypes.string,
  computing: PropTypes.bool
};

export default ProductRow;
